import { initPdfIfNeed } from './pdfPrinter/initPdf'
import { initUploadFiles } from './uploadFiles/initUploadFiles'
import { isOnDailyPage, isOnEditableDailyPage } from './fromPhp'
import { initPageBeacon, sendBeaconIfPageChanged } from './pageBeacon'
import { initQuill } from './quill'
import { initOverall } from './overall'
import { initSign, sign } from './sign'
import { d3plugin } from './d3plugin/d3plugin'
import { initValidate } from './validation/initValidate'
import { initCalendar } from './components/calendar'
import { arrAppend } from './fun-js-lib/arr'
import { initSentry } from './components/sentry'
import { initLiveSearch } from './live-search'

initSentry()

document.addEventListener('DOMContentLoaded', () => {
  let functions = [
    d3plugin,
    initPdfIfNeed,
    initLiveSearch,
  ]

  if (isOnDailyPage()) {
    arrAppend(functions, [
      initCalendar,
      initUploadFiles,
      initQuill,
      initOverall
    ])
  }

  if (isOnEditableDailyPage()) {
    arrAppend(functions, [
      initPageBeacon,
      initSign,
      initValidate
    ])
    window.sign = sign;
    window.sendBeaconIfPageChanged = sendBeaconIfPageChanged;
  }

  functions.forEach(f => {
    try {
      f()
    } catch (e) {
      console.error(e)
    }
  })

})